var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6104_35730)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6104_35730",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9348 35C55.9038 35 57.5272 36.6049 57.2357 38.5523C56.5105 43.3983 54.3132 47.9376 50.8989 51.5311C46.6609 55.9916 40.8716 58.6541 34.7269 58.9686C28.5821 59.2831 22.5513 57.2257 17.8799 53.2212C13.2086 49.2168 10.2537 43.5712 9.62544 37.4505C8.9972 31.3299 10.7437 25.2017 14.5041 20.3318C18.2645 15.4619 23.7517 12.2222 29.8322 11.2819C35.9127 10.3416 42.1221 11.7725 47.1779 15.2791C51.251 18.1041 54.3246 22.1023 56.0192 26.7C56.7001 28.5475 55.4366 30.4488 53.5087 30.8488C51.5807 31.2488 49.727 29.9854 48.9314 28.1842C47.6865 25.3658 45.6832 22.92 43.1142 21.1382C39.5605 18.6735 35.1959 17.6677 30.9219 18.3286C26.6479 18.9896 22.791 21.2667 20.1478 24.6898C17.5046 28.1128 16.277 32.4203 16.7186 36.7225C17.1602 41.0247 19.2372 44.9929 22.5207 47.8077C25.8042 50.6224 30.0432 52.0686 34.3624 51.8475C38.6815 51.6264 42.7508 49.755 45.7297 46.6197C47.8831 44.3532 49.3478 41.5514 49.9942 38.5389C50.4073 36.6137 51.9658 35 53.9348 35Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9348 35C55.9038 35 57.5272 36.6049 57.2357 38.5523C56.5105 43.3983 54.3132 47.9376 50.8989 51.5311C46.6609 55.9916 40.8716 58.6541 34.7269 58.9686C28.5821 59.2831 22.5513 57.2257 17.8799 53.2212C13.2086 49.2168 10.2537 43.5712 9.62544 37.4505C8.9972 31.3299 10.7437 25.2017 14.5041 20.3318C18.2645 15.4619 23.7517 12.2222 29.8322 11.2819C35.9127 10.3416 42.1221 11.7725 47.1779 15.2791C51.251 18.1041 54.3246 22.1023 56.0192 26.7C56.7001 28.5475 55.4366 30.4488 53.5087 30.8488C51.5807 31.2488 49.727 29.9854 48.9314 28.1842C47.6865 25.3658 45.6832 22.92 43.1142 21.1382C39.5605 18.6735 35.1959 17.6677 30.9219 18.3286C26.6479 18.9896 22.791 21.2667 20.1478 24.6898C17.5046 28.1128 16.277 32.4203 16.7186 36.7225C17.1602 41.0247 19.2372 44.9929 22.5207 47.8077C25.8042 50.6224 30.0432 52.0686 34.3624 51.8475C38.6815 51.6264 42.7508 49.755 45.7297 46.6197C47.8831 44.3532 49.3478 41.5514 49.9942 38.5389C50.4073 36.6137 51.9658 35 53.9348 35Z",
    stroke: "url(#paint0_linear_6104_35730)",
    strokeWidth: 22,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_6104_35730)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6104_35730",
    x1: 47.4592,
    y1: 17.1224,
    x2: 57.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6104_35730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.dfe7c593c9bc6c362bf4557bf9226ad9.svg";
export { ForwardRef as ReactComponent };